var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"px-3"},[_c('h2',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }